<template>
  <v-dialog
  persistent
  v-model="showDialog"
  max-width="400px"
  :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <span class="edit-button" slot="activator">edit</span>
    <v-card :class="{'no-border': $vuetify.breakpoint.xsOnly}">
      <v-form v-model="valid">
      <v-container class="modal-pad">
        <v-layout row align-center wrap mb-3>
          <v-flex xs10 style="height:30px;">
            <span class="subheading">Edit invoice details</span>
          </v-flex>
          <v-flex xs2 class="text-xs-right">
            <span class="done-button" @click="onSaveChanges" v-if='valid'>done</span>
            <span class="done-button disabled" v-if='!valid'>done</span>
          </v-flex>
        </v-layout>
        <v-layout row v-if="invoice.status === 'Sent'">
          <v-flex xs12>
            <v-alert color="warning" icon="info" value="true">
              This invoice has been Sent.
            </v-alert>
          </v-flex>
        </v-layout>
        <v-layout column pt-2>
          <v-flex xs12>
            <v-text-field
            v-if="autoIncrement"
            name="invoice_ref_display_only"
            label="Invoice number (automatic)"
            id="invoice_ref_display_only"
            :value="displayedInvoiceNumber"
            type="text"
            autofocus
            ref="focus"
            placeholder=" "
            disabled
            ></v-text-field>
            <v-text-field
            v-else
            name="invoice_ref"
            label="Invoice number (required)"
            id="invoice_ref"
            v-model="addedinvoice_ref"
            type="text"
            autofocus
            ref="focus"
            placeholder=" "
            required
            :rules="[input_required]"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 >
            <v-text-field
            name="poNumber"
            label="PO number (optional)"
            id="poNumber"
            v-model="addedpoNumber"
            type="text"
            placeholder=" "
            ></v-text-field>
          </v-flex>
          <v-flex xs12>
          <v-menu
            lazy
            ref="menu_invoiced_date_ref"
            :close-on-content-click="false"
            v-model="menu_invoiced_date"
            transition="scale-transition"
            :return-value.sync="addedinvoiced_date"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
            >
              <v-text-field
              slot="activator"
              label="Invoiced date"
              v-model="addedinvoicedDateFormatted"
              readonly
              placeholder=" "
              append-icon="date_range"
              clearable
            ></v-text-field>
            <v-date-picker v-model="addedinvoiced_date" @input="$refs.menu_invoiced_date_ref.save(addedinvoiced_date); addedinvoicedDateFormatted = formatDate($event)"
            no-title
            >
            </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12>
            <v-textarea
              name="notes"
              label="Add a note to your invoice"
              id="invoicenote"
              v-model="addedNote"
              clearable
              placeholder=" "
              rows="2"
              hint="Use enter key to add line breaks"
              required></v-textarea>
          </v-flex>
        </v-layout>
      </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatDate } from '@/components/Mixins/formatDate'

export default {
  name: 'EditInvoiceDetailsModal',
  props: {
    invoice: Object,
    invoicedDateFormatted: String,
    autoIncrement: Boolean,
    displayedInvoiceNumber: String
  },
  mixins: [formatDate],
  data () {
    return {
      valid: false,
      showDialog: false,
      menu_invoiced_date: false,
      addedinvoice_ref: this.invoice.invoice_ref,
      addedpoNumber: this.invoice.poNumber,
      addedNote: this.invoice.note,
      addedinvoiced_date: this.invoice.invoiced_date,
      addedinvoicedDateFormatted: this.invoicedDateFormatted,
      input_required: value => !!value || 'Required.'
    }
  },
  watch: {
    showDialog (val) {
      if (!val) return
      requestAnimationFrame(() => {
        this.$refs.focus.focus()
      })
    }
  },
  methods: {
    saveDate (date, dateField) {
      this['menu_' + dateField] = false
    },
    cancelDate (dateField) {
      this['menu_' + dateField] = false
    },
    clearDate (dateField) {
      // pass the job.date object then set it to zilch. clear the job.chasedate
      this.invoice[dateField] = ''
      this[dateField + 'Formatted'] = ''
      this['menu_' + dateField] = false
    },
    toggleDialog () {
      this.showDialog = !this.showDialog
    },
    onSaveChanges () {
      if (this.addedinvoicedDateFormatted == null) {
        this.addedinvoiced_date = null
      }
      this.$emit('return-invoice-details', {
        invoice_ref: this.addedinvoice_ref,
        poNumber: this.addedpoNumber,
        invoiced_date: this.addedinvoiced_date,
        note: this.addedNote,
        invoicedDateFormatted: this.addedinvoicedDateFormatted
      })
      this.showDialog = false
    }
  }

}
</script>
